import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { CurrentUserOwnerPickerField } from './CurrentUserOwnerPickerField';

const currentUserOwnerPickerFormField = FormFieldBlueprint.make({
  name: 'current-user-owner-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'CurrentUserOwnerPicker',
        component: CurrentUserOwnerPickerField,
      }),
  },
});

export const scaffolderOwnerPickerModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [currentUserOwnerPickerFormField],
});
